// src/App.js

import React, { useContext } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

// Auth context provider
import { AuthProvider, AuthContext } from "./context/AuthContext";

// Page components
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Products from "./pages/Products";
import Inventory from "./pages/Inventory";
import Sales from "./pages/Sales";
import Customers from "./pages/Customers";
import Debts from "./pages/Debts";
import Receipts from "./pages/Receipts";

// Wrap routes in a separate function so we can use useContext inside
function AppRoutes() {
  const { user } = useContext(AuthContext);

  return (
    <Routes>
      <Route
        path="/"
        element={user ? <Navigate to="/dashboard" replace /> : <Login />}
      />
      <Route
        path="/dashboard"
        element={user ? <Dashboard /> : <Navigate to="/" replace />}
      />
      <Route
        path="/products"
        element={user ? <Products /> : <Navigate to="/" replace />}
      />
      <Route
        path="/inventory"
        element={user ? <Inventory /> : <Navigate to="/" replace />}
      />
      <Route
        path="/sales"
        element={user ? <Sales /> : <Navigate to="/" replace />}
      />
      <Route
        path="/customers"
        element={user ? <Customers /> : <Navigate to="/" replace />}
      />
      <Route
        path="/debts"
        element={user ? <Debts /> : <Navigate to="/" replace />}
      />
      <Route
        path="/receipts"
        element={user ? <Receipts /> : <Navigate to="/" replace />}
      />
      {/* fallback: redirect unknown routes to login */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
